import { AxiosRequestConfig } from 'axios'

export interface TicketScanStatsByStoreParams {
  startDate: string
  endDate: string
  storeIds?: string
}

export interface TicketScanStatsByStoreResponse {
  data: Array<{
    local: string
    porcentaje: number
  }>
}

const getTicketScanStatsByStore = (params: TicketScanStatsByStoreParams): AxiosRequestConfig => ({
  url: '/dashboard/tickets/scan-stats-by-store',
  method: 'GET',
  params,
})

export { getTicketScanStatsByStore }
